<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: 'app',
    mounted () {
    },
    // 全局监听路由跳转
    watch: {
      '$route' (to, from) {
        to.meta.refer = from
        this.$logger.debug(`路由跳转from: ${from.path} to: ${to.path}`)
      }
    },
  }
</script>
<style>
  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    height: 100%;
  }
  @import './assets/font.css';
</style>



// WEBPACK FOOTER //
// App.vue?2448d44a